import React from 'react';
import { useNavigate } from 'react-router-dom';
import GoogleImg from '../assets/GoogleImg.png';

interface SessionExpiredModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleLogin = () => {
    navigate('/login');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-background border border-white/10 rounded-xl p-6 max-w-sm w-full mx-4">
        <div className="text-center mb-6">
          <h2 className="text-2xl font-semibold text-white mb-2">
            Sessão Expirada
          </h2>
          <p className="text-white/60 text-sm">
            Sua sessão expirou. Por favor, faça login novamente para continuar.
          </p>
        </div>
        <div className="flex flex-col gap-3">
          <button
            onClick={onClose}
            className="w-full py-3 px-4 rounded-lg bg-white/10 hover:bg-white/20 text-white transition-colors"
          >
            Continuar sem Login
          </button>
          <button
            onClick={handleLogin}
            className="w-full py-3 px-4 rounded-lg bg-white hover:bg-white/90 text-gray-900 transition-colors flex items-center justify-center gap-2"
          >
            <img src={GoogleImg} alt="Google" className="w-5 h-5" />
            Fazer Login com Google
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal; 